export function VillesActions({ children, selectedItems, onDeselectAll }) {}
